import { useEffect } from 'react';

export const useGtm = (gtmConsoleId: string) => {

  const pushGTMEvent = (eventName: string) => {
    window?.dataLayer?.push({ event: eventName });
  };

  const addGtmScript = () => {
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                          })(window,document,'script','dataLayer','${gtmConsoleId}')`;
    script.defer = true;
    document.head.appendChild(script);
  };

  const removeGtmScript = () => {
    const script = document.querySelector(
      'script[src^="https://www.googletagmanager.com/gtm.js"]',
    );
    if (script) {
      script.remove();
    }
  };

  useEffect(() => {
    if (gtmConsoleId) {
      addGtmScript();
      return () => {
        removeGtmScript();
      }
    }
  }, []);

  return {
    pushGTMEvent,
  }
}
